define("new-schedule/components/rewards-animation", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@ember/runloop", "@glimmer/tracking", "later/utils/time-format"], function (_exports, _component, _templateFactory, _object, _service, _runloop, _tracking, _timeFormat) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2, _descriptor3;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.showMonthlyRewardAnimation}}
    <div
      class="tRW--animationContainer"
      {{did-insert this.setRewardsInLocalStorage}}
    >
      {{#each (repeat 40) as |confetti index|}}
        <div class="tRW--confetti__{{add index 1}}"></div>
      {{/each}}
    </div>
  {{/if}}
  
  */
  {
    "id": "z2WOQvvX",
    "block": "[[[41,[30,0,[\"showMonthlyRewardAnimation\"]],[[[1,\"  \"],[11,0],[24,0,\"tRW--animationContainer\"],[4,[38,1],[[30,0,[\"setRewardsInLocalStorage\"]]],null],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[28,[37,4],[40],null]],null]],null],null,[[[1,\"      \"],[10,0],[15,0,[29,[\"tRW--confetti__\",[28,[37,5],[[30,2],1],null]]]],[12],[13],[1,\"\\n\"]],[1,2]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"confetti\",\"index\"],false,[\"if\",\"did-insert\",\"each\",\"-track-array\",\"repeat\",\"add\"]]",
    "moduleName": "new-schedule/components/rewards-animation.hbs",
    "isStrictMode": false
  });

  let RewardsAnimation = (_dec = (0, _service.inject)('schedule/post'), (_class = class RewardsAnimation extends _component.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "localStorageManager", _descriptor, this);

      _initializerDefineProperty(this, "schedulePost", _descriptor2, this);

      _initializerDefineProperty(this, "animationSeen", _descriptor3, this);
    }

    get showMonthlyRewardAnimation() {
      return this.createdEnoughPostsForMonthlyReward && !this.seenMonthlyRewardAnimation;
    }

    get createdEnoughPostsForMonthlyReward() {
      return this.currentAccount.postsCreatedThisMonth === this.schedulePost.postCountRewardThreshold;
    }

    get seenMonthlyRewardAnimation() {
      return this.animationSeen || this.localStorageManager.getItem('seen-reward-animation');
    }

    setRewardsInLocalStorage() {
      (0, _runloop.later)(() => {
        this.animationSeen = true;
        this.localStorageManager.setItem('seen-reward-animation', true, (0, _timeFormat.timeUntilEndOfMonth)('hours'));
      }, 3000);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "localStorageManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "schedulePost", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "animationSeen", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "setRewardsInLocalStorage", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setRewardsInLocalStorage"), _class.prototype)), _class));
  _exports.default = RewardsAnimation;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, RewardsAnimation);
});